import { render, staticRenderFns } from "./MessageListStatusToggle.vue?vue&type=template&id=2ef8fd15&scoped=true"
import script from "./MessageListStatusToggle.vue?vue&type=script&lang=js"
export * from "./MessageListStatusToggle.vue?vue&type=script&lang=js"
import style0 from "./MessageListStatusToggle.vue?vue&type=style&index=0&id=2ef8fd15&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ef8fd15",
  null
  
)

export default component.exports